import React, { Component } from "react";
import PropTypes from "prop-types";
import { Provider } from "react-firebase";
import app from "../firebase-config";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import getMuiTheme from "material-ui/styles/getMuiTheme";

import theme from "./theme";
import App from "./App";

export default class UserApp extends Component {
  static get childContextTypes() {
    return {
      filter: PropTypes.func,
      selector: PropTypes.string,
      path: PropTypes.string,
      colors: PropTypes.array,
      card: PropTypes.string
    };
  }

  getChildContext() {
    return {
      filter: this.props.filter,
      selector: this.props.selector,
      path: this.props.path,
      colors: this.props.colors,
      card: this.props.card
    };
  }

  render() {
    return (
      <MuiThemeProvider muiTheme={getMuiTheme(theme)}>
        <Provider firebaseApp={app}>
          <App />
        </Provider>
      </MuiThemeProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/user/index.js